export default "__VITE_ASSET__BSSEGn2x__"